import type { Resolvers } from 'owa-graph-schema';
import { lazyRecipientCacheQueryWeb } from 'recipientcache-query-web';

/**
 * Please keep these fields alphabetized to minimize merge conflicts
 */
export const webResolvers: Resolvers = {
    /* ======================== */
    /* Resolvers for root types */
    /* ======================== */

    /**
     * The root query type. All queries that fetch data start at the Query type.
     * Resolvers under Query should not have effects
     *
     * See https://graphql.org/learn/schema/#the-query-and-mutation-types
     */
    Query: {
        recipientCache: lazyRecipientCacheQueryWeb,
    },

    /**
     * The root mutation type. All queries that alter data start at the Mutation type.
     * Mutations typically return the mutated data.
     *
     * See https://graphql.org/learn/schema/#the-query-and-mutation-types
     */
    Mutation: {},

    SubstrateSearchSuggestionsResponseGroup: {
        __resolveType(_substrateSearchSuggestionsResponseGroup, _context, _info) {
            return 'SubstrateSearchSuggestionsResponsePeopleGroup';
        },
    },
};
